module.exports = __webpack_public_path__ + "img/button-bookmark-filled.2172c19e.svg";